import { axiosAction } from '../../utils/axiosAction';
import {
  HIERARCHY,
  HIERARCHY_CHECKED,
  HIERARCHY_CLEAR,
} from '../action-types/hierarchy-types';

export const getHierarchy = brand => async dispatch => {
  return axiosAction.get(
    `/v1/brands/${brand}/hierarchy?code=0`,
    HIERARCHY,
    dispatch,
  );
};

export const setHierarchyCheckedItems = item => async dispatch => {
  try {
    dispatch({
      type: HIERARCHY_CHECKED.SUCCESS,
      payload: item,
    });
  } catch ({ response }) {
    // No-op: Default implementation
  }
};

export const clearHierarchy = () => ({ type: HIERARCHY_CLEAR });

export interface Node {
  id: number;
  rootId: number;
  parentId: number;
  nodetypeId: number;
  nodeTypeName: string;
  nodeTypeCode: string;
  name: string;
  relatedNumber: string;
  level: number;
}
export interface GetHierarchyResponse {
  nodes: Node[];
}
